<template>
  <div>
    <a-dropdown
      v-if="!isLoading"
      v-model="visible"
      :trigger="trigger"
      :disabled="disabled"
      :getPopupContainer="getPopupContainer"
      :overlayStyle="overlayStyle"
      overlayClassName="lm-dropdown-overlay-scroll"
      :placement="dropdownPosition"
    >
      <span :class="{ clickable: !disabled }" @click="!disabled ? visible = true : ''">
        <a-tooltip v-if="Boolean(tooltip)" :placement="tooltipPosition" :getPopupContainer="getPopupContainer">
          <template slot="title">
            <span style="white-space: nowrap">{{ tooltip }}</span>
          </template>
          <slot><span>Click me to open dropdown</span></slot>
        </a-tooltip>
        <slot v-else><span>Click me to open dropdown</span></slot>
      </span>
      <a-menu slot="overlay">
        <a-menu-item v-if="!hideSearchInput">
          <a-input placeholder="Busqueda..." v-model="textSearch" />
          <div v-if="showToggleAll">
            <a-switch
              size="small"
              class="mt-2"
              :checked-children="itemsSelected" un-checked-children="0"
              :default-checked="false"
              @change="onToggleSelect"
            />
          </div>
        </a-menu-item>
        <template v-if="itemsComputed.length">
          <a-menu-item
            v-for="(item, index) of itemsComputed"
            :key="index"
            :class="{ 'selected': isSelected(item) }"
            class="handle"
            @click="onItemPicked(item)"
          >
            {{ item.name || item.text }}
          </a-menu-item>
        </template>
        <template v-else>
          <a-menu-item @click="onClearItemPicked()" class="selected">
            Sin resultados
          </a-menu-item>
        </template>
      </a-menu>
    </a-dropdown>
    <b-skeleton v-else width="160px" height=".8rem" style="margin-bottom: 4px;"></b-skeleton>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import commonsApi from '@/api/commons'

export default {
  components: {
    draggable
  },
  props: {
    container: {
      type: Function,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: null
    },
    tooltipPosition: {
      type: String,
      default: 'top'
    },
    dropdownPosition: {
      type: String,
      default: 'bottomLeft'
    },
    closeAfterPick: {
      type: Boolean,
      default: false
    },
    hideSearchInput: {
      type: Boolean,
      default: false
    },
    template: {
      type: String,
      default: null
    },
    value: {
      type: [Object, Array],
      default: null
    },
    dataItems: {
      type: Array,
      default: () => []
    },
    trigger: {
      type: Array,
      default: () => ['click']
    },
    showToggleAll: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      visible: false,
      overlayStyle: {},
      textSearch: '',
      items: [],
      item: 'null'
    }
  },
  computed: {
    itemsComputed () {
      if (this.textSearch) {
        const search = new RegExp(this.textSearch, 'i')
        return this.items.filter(el => el.name.search(search) !== -1)
      }
      return this.items
    },
    itemsSelected () {
      return this.itemsComputed.filter(el => el.selected).length
    }
  },
  methods: {
    isSelected (item) {
      if (this.value) {
        if (Array.isArray(this.value)) {
          return this.value.find(el => el.id === item.id)
        } else {
          return this.value.id === item.id
        }
      }
      return false
    },
    onToggleSelect (event) {
      this.itemsComputed.forEach(el => {
        el.selected = event
      })
    },
    onClearItemPicked () {
      this.textSearch = ''
      this.item = {}
      this.$emit('input', {})
    },
    onItemPicked (item) {
      if (this.closeAfterPick) {
        this.visible = false
      }
      this.item = item
      this.$emit('input', item)
    },
    // NOTA. esta función es importante para mantener la posición
    // del dropdown. Por defecto usamos el elemento padre, pero podemos mandar una
    // funcion como prop que retorne el elemento del dom (node)
    getPopupContainer () {
      if (this.container) {
        return this.container()
      }
      return this.$parent.$el
    },
    formatItems (items) {
      this.items = items.map((el, index) => {
        if (typeof el === 'string') {
          return { id: index, text: el }
        } else if (typeof el === 'object' && !el?.id) {
          return { id: index, ...el }
        } else {
          return el
        }
      })
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler (val) {
        this.item = val
      }
    },
    dataItems: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val.length) {
          this.formatItems(val)
        }
      }
    }
  },
  async created () {
    this.isLoading = true
    if (this.template === 'user-list') {
      const response = await commonsApi.axiosGetWrapper('/users/all')
      this.items = response.data.items
    } else {
      this.formatItems(this.dataItems)
    }
    this.isLoading = false
  },
  mounted () {
    const appViewHeight = document.getElementById('app-view').clientHeight
    this.overlayStyle = { maxHeight: appViewHeight - ((appViewHeight * 10) % 100) + 'px' }
  }
}
</script>

<style>
.lm-dropdown-overlay-scroll > ul.ant-dropdown-menu {
  min-width: 12em;
  max-height: inherit;
  overflow-y: auto;
}
.lm-dropdown-overlay-scroll.ant-dropdown::before {
  top: 0;
  bottom: 0;
  left: 0;
}
.lm-dropdown-overlay-scroll::-webkit-scrollbar {
  height: 4px;
  width: 4px;
}
.lm-dropdown-overlay-scroll::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: #cccccc;
}
.lm-dropdown-overlay-scroll::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.lm-dropdown-overlay-scroll .ant-dropdown-menu-item.selected {
  background-color: #1890ff;
  color: white;
}
</style>
